import { createContext, useContext, useState, useEffect } from 'react';
import { getTheme } from './theme';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem('regshield_theme') === 'dark';
  });

  const toggle = () => {
    setIsDark(prev => {
      const next = !prev;
      localStorage.setItem('regshield_theme', next ? 'dark' : 'light');
      return next;
    });
  };

  const theme = getTheme(isDark);

  // Apply bg to body so there's no white flash
  useEffect(() => {
    document.body.style.background = theme.bgBase;
    document.body.style.color = theme.textPrimary;
  }, [isDark]);

  return (
    <ThemeContext.Provider value={{ isDark, toggle, theme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);